import { useSimpleFeatureTernary } from "@viagogo/feature";
import { FeatureSetEnum } from "src/shared/constants/FeatureSetEnum";

/**
 * Client-side check for TMHomeProgressiveCarouselLoadingV2 (exp 103068).
 *
 * Variant 1 makes five home data fetches lazy. Four of them (recentlyViewedItems,
 * userEventOption, comingUpForYouItems, connectToSpotify) gate their lazy useQuery on the
 * model field being null — the server's own authoritative variant signal, which cannot skew
 * from the SSR decision. This hook exists for the one surface without a null signal: the
 * hero banner, whose SSR list is empty both for variant users and for pages with genuinely
 * no banners (see HeroBanner.tsx).
 *
 * Participation is recorded server-side on every home render (IsInVariant in
 * GetHomePageViewModel and the mobile/tablet controllers), so this check reads the
 * assignment without recording (record: false).
 */
export const useProgressiveCarouselLoadingV2 = (): boolean =>
  useSimpleFeatureTernary(FeatureSetEnum.TMHomeProgressiveCarouselLoadingV2, false, true, undefined, false) ?? false;
